<app-nav titulo="Informe de scoring" descripcion="Aqui podrá ver toda la información generada por el scoring seleccionado.">
    <div class="report-details">
        <app-data-printer [categories]="categories"></app-data-printer>
    </div>
</app-nav>
